export const initalFilters = {
  status: ['due', 'paid', 'partially_paid', 'due_today', 'over_due'],
};
